module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed": "",
      "centered": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "grey lighten-5"
  }, [_c('v-tabs-slider', {
    staticClass: "amber"
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab,
      attrs: {
        "ripple": "",
        "href": '#' + tab
      }
    }, [_vm._v("\n                " + _vm._s(tab) + "\n            ")])
  })], 2)], 1), _vm._v(" "), (_vm.consents.length === 0) ? _c('div', {
    staticClass: "text-xs-center pt-2 pb-2 grey--text text--darken-1"
  }, [_vm._v("No results")]) : [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.consents && _vm.consents.length > 0) ? _c('v-card', [_c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, _vm._l((_vm.consents), function(item, index) {
    return _c('v-list-tile', {
      key: _vm.key(item),
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.details(item, index)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      class: item.Status
    }, [_vm._v("fa-code-fork")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.DataOwnerCode))]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(item.Intent.ShortDescription))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.userReadable(item.Expiration)))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "visible-hover"
    }, [_vm._v("mode_edit")])], 1)], 1)
  }))], 1) : _vm._e()], 1)], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c512364","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilteredConsentsList.vue
// module id = 334
// module chunks = 2